<template>
  <div class="table-responsive p-0">
    <table class="table main-table">
      <thead>
        <tr>
          <th class="text-center">
            <input type="checkbox">
          </th>
          <th>Name </th>
          <th class="text-center rate-column">Agent<br>Rate %</th>
          <th class="text-center rate-column">Dealer<br>Rate %</th>
          <th class="text-center rate-column">Sureload<br>Rate %</th>
          <th class="text-center">Remaining<br>Balance</th>
          <th class="text-center">Earmarked </th>
          <th class="text-center">Rebate </th>
          <th>Date Created </th>
          <th>Actions</th>
          <th>Availability </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="subRetailerLoading">
          <td colspan="5">
            <div class="text-center">
              <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
            </div>
          </td>
        </tr>
        <tr v-if="!subRetailerLoading && subRetailers.length == 0">
          <td colspan="5">
            <div class="text-center">
              <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
              <p class="text-xs font-weight-bold">No Data Found</p>
            </div>
          </td>
        </tr>
        <tr v-for="(subRetailer, i) in subRetailers" :key="i">
          <td class="text-center">
            <input type="checkbox">
          </td>
          <td>
            <div class="d-flex flex-column justify-content-center">
              <p class="main-text"> {{ subRetailer.name }}</p>
              <p class="sub-text"> {{ subRetailer.branch }}</p>
            </div>
          </td>
          <td class="text-center">{{ subRetailer.agentRate != null ? subRetailer.agentRate.toLocaleString('en-PH') : '0'
          }}</td>
          <td class="text-center">{{ subRetailer.dealerRate != null ? subRetailer.dealerRate.toLocaleString('en-PH') :
            '0'
            }}</td>
          <td class="text-center">{{ subRetailer.sureloadRate != null ? subRetailer.sureloadRate.toLocaleString('en-PH') :
            '0'
            }}</td>
          <td class="text-center">
            <div class="icon-container-action d-inline-flex align-items-center" @click="showSubRetailerBalance(subRetailer)">
              <img src="/img/top-up.png" class="me-2" alt="logo" />
              {{ subRetailer.remainingBalance.toLocaleString("en")
              }}
            </div>

            <!-- <p class="text-xs font-weight-bold mb-0">
              <i class="fa-solid fa-plus-circle ms-2" @click="showSubRetailerBalance(subRetailer)"></i>
              {{ subRetailer.remainingBalance.toLocaleString("en") }}
            </p> -->
          </td>
          <td class="text-center">{{ subRetailer.earMarked != null ? subRetailer.earMarked.toLocaleString('en-PH') : '0'
          }}</td>
          <td class="text-center">{{ subRetailer.rebate != null ? subRetailer.rebate.toLocaleString('en-PH') : '0' }}
          </td>
          <td>
            {{ $format.FormatFullDateTime(subRetailer.timestamp) }}
          </td>
          <td>
            <!-- <a href="javascript:;" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
              data-original-title="Edit user">
              <i class="fas fa-users text-dark cursor-pointer mx-1" data-bs-toggle="tooltip" data-bs-placement="top"
                title="User Access" @click="showSubRetailerUserSidebar(subRetailer)"></i>
            </a>
            <a href="javascript:;" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
              data-original-title="Edit user">
              <i class="fas fa-pencil-alt text-dark cursor-pointer mx-1" data-bs-toggle="tooltip"
                data-bs-placement="top" title="Edit" @click="showSubRetailerDetail(subRetailer)"></i>
            </a> -->

            <div class="d-flex align-items-center justify-content-start">
              <div class="icon-container-action" data-toggle="tooltip" data-original-title="Edit user"
                @click="showSubRetailerUserSidebar(subRetailer)">
                <img src="/img/dealerdark.png" alt="logo" />
              </div>
              <div class="icon-container-action" data-toggle="tooltip" data-original-title="Edit user"
                @click="showSubRetailerDetail(subRetailer)">
                <img src="/img/updatedark.png" alt="logo" />
              </div>
              <!--<div class="icon-container-action" @click="showTransactionsSidebar(subRetailer)">
                <img src="/img/transactiondark.png" alt="logo" />
              </div>-->
              <div class="icon-container-action d-none" @click="showSettingsSidebar(subRetailer)">
                <img src="/img/settings.png" alt="logo" />
              </div>
            </div>





            <!-- <a
              href="javascript:;"
              class="text-secondary font-weight-bold text-xs"
              data-toggle="tooltip"
              data-original-title="Edit user"
            >
              <i
                class="fas fa-trash text-dark cursor-pointer mx-1"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Delete"
                @click="notImplemented"
              ></i>
            </a> -->
          </td>
          <td>
            <label class="switch">
              <input type="checkbox" v-model="subRetailer.isActive" @change="handleChange(subRetailer)" />
              <span class="slider round"></span>
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <GlobalModal :show="modal.show" :title="modal.title" :message="modal.message" :type="modal.type"
    @confirm="modal.onConfirm" @cancel="modal.onCancel" @close="modal.show = false" />
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../../assets/no-data.json";
import searchingJSON from "./../../../../assets/searching.json";
import GlobalModal from "@/components/GlobalModal.vue";

export default {
  data() {
    return {
      noDataJSON,
      searchingJSON,
      subRetailerUsersAll: [],
      modal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  components: {
    GlobalModal
  },
  computed: {
    ...mapState({
      subRetailers: (state) => state.retailerController.filteredSubRetailers,
      subRetailerLoading: (state) => state.retailerController.subRetailerLoading,
      subRetailerUsers: (state) => state.retailerController.subRetailerUsers,
    }),
  },
  methods: {
    showSettingsSidebar(subRetailer) {
      this.setShowSettingsSidebar(true);
    },

    showTransactionsSidebar(subRetailer) {
      this.setShowTransactionsSidebar(true);
    },
    ...mapMutations({
      setShowSubRetailerBalanceSidebar: "retailerController/SET_ShowSubRetailerBalanceSidebar",
      setShowSubRetailerUserSidebar: "retailerController/SET_ShowSubRetailerUserSidebar",
      setShowSubRetailerSidebar: "retailerController/SET_ShowSubRetailerSidebar",
      selectSubRetailer: "retailerController/SELECT_SubRetailer",

      setShowSettingsSidebar: "retailerController/SET_ShowSettingsSidebar",
      setShowTransactionsSidebar: "retailerController/SET_ShowTransactionsSidebar",
    }),
    ...mapActions({
      getSubRetailerUsers: "retailerController/GetSubRetailerUsers",
      updateSubRetailerVisibility: "retailerController/UpdateSubRetailerVisibility",
    }),
    showSubRetailerDetail(subRetailer) {
      this.selectSubRetailer(subRetailer);
      this.setShowSubRetailerSidebar(true);
    },
    async showSubRetailerUserSidebar(subRetailer) {
      this.selectSubRetailer(subRetailer);
      this.setShowSubRetailerUserSidebar(true);
      await this.getSubRetailerUsers();
    },
    showSubRetailerBalance(subRetailer) {
      this.selectSubRetailer(subRetailer);
      this.setShowSubRetailerBalanceSidebar(true);
      console.log("setShowSubRetailerBalanceSidebar:", this.setShowSubRetailerBalanceSidebar);
    },
    notImplemented() {
      alert("not yet implemented.");
    },
    handleChange: async function (subRetailer) {
      const action = subRetailer.isActive ? 'activate' : 'deactivate';
      subRetailer.isActive = !subRetailer.isActive;
      const confirmed = await this.showModal(
        'confirmation',
        'Change User Visibility',
        `Are you sure you want to ${action}  this user?`
      );
      if (confirmed) {
        try {
          var result = await this.updateSubRetailerVisibility({
            subRetailerID: subRetailer.subRetailerID,
            isVisible: !subRetailer.isActive,
          });

          if (result) {
            subRetailer.isActive = !subRetailer.isActive;
          }
        } catch (error) {
          this.showModal(
            'error',
            'An error occurred while adding rate.',
          );
        }
      }
    },

    showModal(type, title, message) {
      return new Promise((resolve) => {
        this.modal = {
          show: true,
          type,
          title,
          message,
          onConfirm: () => {
            this.modal.show = false;
            resolve(true);
          },
          onCancel: () => {
            this.modal.show = false;
            resolve(false);
          },
        };
      });
    }
  },
};
</script>

<style scoped>
/* Rate columns with narrower width */
.rate-column {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>